'use strict';

var _ = require('lodash');
var SeasonalityToolbarController = function SeasonalityToolbarController($rootScope, $scope, searchCriteriaConstantsService, dataRetrieverConstants, seasonalityConstants, userSecureService, configurationService, searchResultMarketsService, featureToggleService) {
  var NON_CODE_SHARE_MARKETS = _.chain(configurationService.getNonCodeShareMarkets()).invertBy(function (item) {
    return item.origin + '-' + item.destination;
  }).mapValues(function () {
    return true;
  }).value();
  $scope.initialScreen = searchCriteriaConstantsService.SEASONALITY;
  $scope.calendarModes = [{
    label: seasonalityConstants.CALENDAR_MODES.DA_HSE,
    value: dataRetrieverConstants.SEASONALITY_DA_HOLIDAY_SPECIAL_EVENT,
    hideIfFeature: !featureToggleService.isEnabled('DYNAMIC_AVAILABILITY;DYNAMIC_AVAILABILITY_SEASONALITY'),
    selected: featureToggleService.isEnabled('DYNAMIC_AVAILABILITY;DYNAMIC_AVAILABILITY_SEASONALITY')
  }, {
    label: seasonalityConstants.CALENDAR_MODES.DA_SEASON,
    value: dataRetrieverConstants.DA_SEASONALITY_SEASON_MODE,
    hideIfFeature: !featureToggleService.isEnabled('DYNAMIC_AVAILABILITY;DYNAMIC_AVAILABILITY_SEASONALITY')
  }, {
    label: seasonalityConstants.CALENDAR_MODES.DEMAND,
    value: featureToggleService.isEnabled('POOLED_SEASONALITY') ? dataRetrieverConstants.SEASONALITY_POOLED_MODE : dataRetrieverConstants.SEASONALITY_DEMAND_MODE,
    selected: featureToggleService.isEnabled('REVENUE_OPTIMIZER') && !featureToggleService.isEnabled('DYNAMIC_AVAILABILITY;DYNAMIC_AVAILABILITY_SEASONALITY'),
    hideIfFeature: featureToggleService.isEnabled('DYNAMIC_AVAILABILITY;DYNAMIC_AVAILABILITY_SEASONALITY')
  }, {
    label: seasonalityConstants.CALENDAR_MODES.SHOW_UP,
    value: dataRetrieverConstants.SEASONALITY_SHOW_UP_MODE,
    hideIfFeature: featureToggleService.isEnabled('DYNAMIC_AVAILABILITY;DYNAMIC_AVAILABILITY_SEASONALITY')
  }];
  $scope.triggerSearch = function () {
    var marketList = _.filter(searchResultMarketsService.getMarkets(), function (market) {
      return NON_CODE_SHARE_MARKETS[market.value];
    });
    _.set($scope.screenState, 'searchResultMarkets', marketList);
    $rootScope.$broadcast('search-criteria:searchChangeEvent');
  };
  $scope.toggleCalendarMode = function (calendarMode) {
    _.forEach($scope.calendarModes, function (mode) {
      mode.selected = mode.value === calendarMode.value;
    });
    $scope.screenState.calendarMode = calendarMode.value;
    $scope.screenState.calendarModeLabel = calendarMode.label;
  };
  $scope.hasShowUpSeasonalityWriteAccess = function () {
    return userSecureService.hasAuthorization('show-up-seasonality', 'write');
  };
  $scope.hasDASeasonalityFeature = function hasSeasonalityFeature() {
    return featureToggleService.isEnabled('DYNAMIC_AVAILABILITY;DYNAMIC_AVAILABILITY_SEASONALITY');
  };
};
SeasonalityToolbarController.$inject = ['$rootScope', '$scope', 'SearchCriteriaConstantsService', 'DataRetrieverConstantsService', 'SeasonalityConstants', 'UserSecureService', 'ConfigurationService', 'SearchResultMarketsService', 'FeatureToggleService'];
module.exports = SeasonalityToolbarController;